module.exports = __webpack_public_path__ + "img/rocket.386bfd39.svg";